import * as React from 'react';
import { useLocation } from 'react-router';

import { useApolloClient } from '@apollo/client';

import { variantIdFromUrl } from '@notino/shared/client-utils';
import { GetLoadingProductQuery } from '@notino/shared/definitions/types';

import getLoadingProductQuery from '@containers/ProductDetailContainer/queries/loadingProduct.graphql';

import { SpaLoadingSkeleton } from './SpaLoadingSkeleton';

export const Loading: React.FC = () => {
  const { cache } = useApolloClient();
  const { pathname } = useLocation();

  const variantId = variantIdFromUrl(pathname);

  const loadingProduct = variantId
    ? cache.readQuery<GetLoadingProductQuery>({
        query: getLoadingProductQuery,
        variables: { id: variantId },
      })
    : null;

  return (
    <SpaLoadingSkeleton
      product={loadingProduct?.vpProductById}
      imageDomainPath={loadingProduct?.Settings?.imageDomainPath}
    />
  );
};
